import { WEB_CLIENT } from '../servers';

export const postMessage = (text) => {
  window.postMessage(text, WEB_CLIENT);
};
